/*@ngInject*/
module.exports = function($sce, $rootScope, data, $uibModalInstance) {
    const vm = this;

    vm.modalInstace = $uibModalInstance;
    vm.rootscope = $rootScope;
    vm.data = data;

    vm.$onInit = function() {
        const mapUrls = vm.rootscope.mapUrls;
        vm.akisUrl = mapUrls.akisUrl;
        vm.opisUrl = mapUrls.opisUrl;
    };


    vm.isNotEmpty = (field) => field && field !== 'Null';

    vm.isOpisUrl = () => vm.data.url.includes(vm.opisUrl);

    vm.isAkisUrl = () => vm.data.url.includes(vm.akisUrl);

    vm.close = () => {
        $rootScope.isModalOpen = false;
    };

    vm.trustedHtml = (text) => $sce.trustAsHtml(text);
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/road_elements/akis-opis-modal.directive.js
 **/